import React, { useEffect } from 'react'

import { StatusSummary } from 'components/ui/status-summary'

import { connect } from 'containers/store'

import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions'
import { GettyStore, GettyAppState } from 'domains/org/getty/store'
import { bundleProcessingFailed, errorMessage } from 'domains/org/getty/utils/bundles'

import { BundleSummary, Bundle } from 'generated/mos/org/getty/publish'

import { pick } from 'helpers/core'
import { statusSelector } from 'helpers/status'

import styled from 'styled'

type ActionProps = Pick<typeof actionCreators, 'gettyGetListBundleSummariesRequest'>
type ConnectedProps = Pick<GettyAppState, 'publishBundleSummaries'>
type DirectProps = { projectId: string }
type Props = ConnectedProps & DirectProps & ActionProps

const ErrorsListView = (props: Props) => {
  const {
    projectId,
    gettyGetListBundleSummariesRequest,
    publishBundleSummaries,
  } = props

  // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { gettyGetListBundleSummariesRequest() }, [gettyGetListBundleSummariesRequest])

  const bundleSummaries: ReadonlyArray<BundleSummary.Entity> | undefined = statusSelector.data(publishBundleSummaries);
  const errors = bundleSummaries && bundleSummaries
    .filter(({lastPublishedBundle}: BundleSummary.Entity): boolean => !!(lastPublishedBundle && bundleProcessingFailed(lastPublishedBundle)))
    .map(({lastPublishedBundle}) => ({text: errorMessage(lastPublishedBundle as Bundle.Entity)}))
  return <>{errors && errors.length > 0 && <StatusSummary error={errors} />}</>;
}

export const ErrorsList = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  ({ getty }) => pick(getty, 'publishBundleSummaries' ),
  pick(actionCreators, 'gettyGetListBundleSummariesRequest')
)(ErrorsListView)
